// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WikiRouteImport } from './routes/wiki'
import { Route as PremiumRouteImport } from './routes/premium'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as AddedRouteImport } from './routes/added'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SummariesIndexRouteImport } from './routes/summaries/index'
import { Route as GuildsIndexRouteImport } from './routes/guilds/index'
import { Route as SummariesSummaryIdRouteImport } from './routes/summaries/$summaryId'
import { Route as GuildsGuildIdRouteImport } from './routes/guilds/$guildId'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as WikiIndexRouteImport } from './routes/wiki/index'
import { Route as LegalIndexRouteImport } from './routes/legal/index'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalPaidServicesRouteImport } from './routes/legal/paid-services'
import { Route as GuildsGuildIdIndexRouteImport } from './routes/guilds/$guildId/index'
import { Route as GuildsGuildIdTemplatesRouteImport } from './routes/guilds/$guildId/templates'
import { Route as GuildsGuildIdSettingsRouteImport } from './routes/guilds/$guildId/settings'
import { Route as GuildsGuildIdCreateRouteImport } from './routes/guilds/$guildId/create'
import { Route as GuildsGuildIdAnalyticsRouteImport } from './routes/guilds/$guildId/analytics'
import { Route as WikiUserGuidesIndexRouteImport } from './routes/wiki/user-guides/index'
import { Route as WikiReferenceIndexRouteImport } from './routes/wiki/reference/index'
import { Route as WikiGettingStartedIndexRouteImport } from './routes/wiki/getting-started/index'
import { Route as WikiDeveloperIndexRouteImport } from './routes/wiki/developer/index'
import { Route as WikiAdvancedIndexRouteImport } from './routes/wiki/advanced/index'
import { Route as WikiReferenceCommandsRouteImport } from './routes/wiki/reference/commands'
import { Route as WikiGettingStartedQuickStartRouteImport } from './routes/wiki/getting-started/quick-start'
import { Route as WikiDeveloperMarkdownTestRouteImport } from './routes/wiki/developer/markdown-test'
import { Route as WikiDeveloperComponentsRouteImport } from './routes/wiki/developer/components'
import { Route as GuildsGuildIdSummarySummaryIdRouteImport } from './routes/guilds/$guildId/summary/$summaryId'
import { Route as GuildsGuildIdDetailsGiveawayIdRouteImport } from './routes/guilds/$guildId/details/$giveawayId'

const WikiRoute = WikiRouteImport.update({
            id: '/wiki',path: '/wiki',getParentRoute: () => rootRouteImport
          })
const PremiumRoute = PremiumRouteImport.update({
            id: '/premium',path: '/premium',getParentRoute: () => rootRouteImport
          })
const LegalRoute = LegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => rootRouteImport
          })
const InviteRoute = InviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => rootRouteImport
          })
const AddedRoute = AddedRouteImport.update({
            id: '/added',path: '/added',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SummariesIndexRoute = SummariesIndexRouteImport.update({
            id: '/summaries/',path: '/summaries/',getParentRoute: () => rootRouteImport
          })
const GuildsIndexRoute = GuildsIndexRouteImport.update({
            id: '/guilds/',path: '/guilds/',getParentRoute: () => rootRouteImport
          })
const SummariesSummaryIdRoute = SummariesSummaryIdRouteImport.update({
            id: '/summaries/$summaryId',path: '/summaries/$summaryId',getParentRoute: () => rootRouteImport
          })
const GuildsGuildIdRoute = GuildsGuildIdRouteImport.update({
            id: '/guilds/$guildId',path: '/guilds/$guildId',getParentRoute: () => rootRouteImport
          })
const AuthErrorRoute = AuthErrorRouteImport.update({
            id: '/auth/error',path: '/auth/error',getParentRoute: () => rootRouteImport
          })
const WikiIndexRoute = WikiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WikiRoute
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LegalRoute
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LegalRoute
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LegalRoute
          })
const LegalPaidServicesRoute = LegalPaidServicesRouteImport.update({
            id: '/paid-services',path: '/paid-services',getParentRoute: () => LegalRoute
          })
const GuildsGuildIdIndexRoute = GuildsGuildIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuildsGuildIdRoute
          })
const GuildsGuildIdTemplatesRoute = GuildsGuildIdTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => GuildsGuildIdRoute
          })
const GuildsGuildIdSettingsRoute = GuildsGuildIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => GuildsGuildIdRoute
          })
const GuildsGuildIdCreateRoute = GuildsGuildIdCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => GuildsGuildIdRoute
          })
const GuildsGuildIdAnalyticsRoute = GuildsGuildIdAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => GuildsGuildIdRoute
          })
const WikiUserGuidesIndexRoute = WikiUserGuidesIndexRouteImport.update({
            id: '/user-guides/',path: '/user-guides/',getParentRoute: () => WikiRoute
          })
const WikiReferenceIndexRoute = WikiReferenceIndexRouteImport.update({
            id: '/reference/',path: '/reference/',getParentRoute: () => WikiRoute
          })
const WikiGettingStartedIndexRoute = WikiGettingStartedIndexRouteImport.update({
            id: '/getting-started/',path: '/getting-started/',getParentRoute: () => WikiRoute
          })
const WikiDeveloperIndexRoute = WikiDeveloperIndexRouteImport.update({
            id: '/developer/',path: '/developer/',getParentRoute: () => WikiRoute
          })
const WikiAdvancedIndexRoute = WikiAdvancedIndexRouteImport.update({
            id: '/advanced/',path: '/advanced/',getParentRoute: () => WikiRoute
          })
const WikiReferenceCommandsRoute = WikiReferenceCommandsRouteImport.update({
            id: '/reference/commands',path: '/reference/commands',getParentRoute: () => WikiRoute
          })
const WikiGettingStartedQuickStartRoute = WikiGettingStartedQuickStartRouteImport.update({
            id: '/getting-started/quick-start',path: '/getting-started/quick-start',getParentRoute: () => WikiRoute
          })
const WikiDeveloperMarkdownTestRoute = WikiDeveloperMarkdownTestRouteImport.update({
            id: '/developer/markdown-test',path: '/developer/markdown-test',getParentRoute: () => WikiRoute
          })
const WikiDeveloperComponentsRoute = WikiDeveloperComponentsRouteImport.update({
            id: '/developer/components',path: '/developer/components',getParentRoute: () => WikiRoute
          })
const GuildsGuildIdSummarySummaryIdRoute = GuildsGuildIdSummarySummaryIdRouteImport.update({
            id: '/summary/$summaryId',path: '/summary/$summaryId',getParentRoute: () => GuildsGuildIdRoute
          })
const GuildsGuildIdDetailsGiveawayIdRoute = GuildsGuildIdDetailsGiveawayIdRouteImport.update({
            id: '/details/$giveawayId',path: '/details/$giveawayId',getParentRoute: () => GuildsGuildIdRoute
          })





const LegalRouteChildren = {
  LegalPaidServicesRoute: LegalPaidServicesRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute,LegalIndexRoute: LegalIndexRoute
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)




const WikiRouteChildren = {
  WikiIndexRoute: WikiIndexRoute,WikiDeveloperComponentsRoute: WikiDeveloperComponentsRoute,WikiDeveloperMarkdownTestRoute: WikiDeveloperMarkdownTestRoute,WikiGettingStartedQuickStartRoute: WikiGettingStartedQuickStartRoute,WikiReferenceCommandsRoute: WikiReferenceCommandsRoute,WikiAdvancedIndexRoute: WikiAdvancedIndexRoute,WikiDeveloperIndexRoute: WikiDeveloperIndexRoute,WikiGettingStartedIndexRoute: WikiGettingStartedIndexRoute,WikiReferenceIndexRoute: WikiReferenceIndexRoute,WikiUserGuidesIndexRoute: WikiUserGuidesIndexRoute
}

const WikiRouteWithChildren = WikiRoute._addFileChildren(WikiRouteChildren)




const GuildsGuildIdRouteChildren = {
  GuildsGuildIdAnalyticsRoute: GuildsGuildIdAnalyticsRoute,GuildsGuildIdCreateRoute: GuildsGuildIdCreateRoute,GuildsGuildIdSettingsRoute: GuildsGuildIdSettingsRoute,GuildsGuildIdTemplatesRoute: GuildsGuildIdTemplatesRoute,GuildsGuildIdIndexRoute: GuildsGuildIdIndexRoute,GuildsGuildIdDetailsGiveawayIdRoute: GuildsGuildIdDetailsGiveawayIdRoute,GuildsGuildIdSummarySummaryIdRoute: GuildsGuildIdSummarySummaryIdRoute
}

const GuildsGuildIdRouteWithChildren = GuildsGuildIdRoute._addFileChildren(GuildsGuildIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AddedRoute: AddedRoute,InviteRoute: InviteRoute,LegalRoute: LegalRouteWithChildren,PremiumRoute: PremiumRoute,WikiRoute: WikiRouteWithChildren,AuthErrorRoute: AuthErrorRoute,GuildsGuildIdRoute: GuildsGuildIdRouteWithChildren,SummariesSummaryIdRoute: SummariesSummaryIdRoute,GuildsIndexRoute: GuildsIndexRoute,SummariesIndexRoute: SummariesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)